const $ = require('jquery');
import _ from "underscore";
import QuickWizard from '../../components/QuickWizard/QuickWizard';
import run from '../../utilities/run';
import {validateOnAllSelectChanges} from "../../utilities/select2able";
import render from "../../utilities/render";


// Live form from jsp
run("#shippment-tracking-number", ()=>{
  const el = $("#shippment-tracking-number");
  shipmentTracking(el);
});


function shipmentTracking(el){
	$( "#tracking-number-select" ).change(function() {
		var url = el.data("trackinginfo-url");
		var trackingNumber = $('#tracking-number-select :selected').val();
		var retailerId =  $('#tracking-info-retailer-id').val();
		var carrier =  $('#tracking-info-carrier-name').val();
		$('#shipment-tracking-loader').show();
		$("#tracking-info-div").hide();
		
	    $.ajax({
			url: url,
			type: 'POST',
			dataType: 'html',
			data:  ({
			 selectedTrackingNumber : trackingNumber,
			 carrier : carrier,
			 retailerId : retailerId
			}),
	       	success: function(resp){
				if(resp) {
					$('#shipment-tracking-loader').hide();
					console.log('success: ');
					$("#tracking-info-div").html(resp);
					$("#tracking-info-div").show();
					
				} else {
					$('#shipment-tracking-loader').hide();
					console.log('error: ');
						$("#tracking-info-div").show();
						
				}
			},
			error: function(xhr,status,error) {
				console.log('error 1: ');
				$('#shipment-tracking-loader').hide();
					$("#tracking-info-div").show();
					
			}
		});
		
	});
}


// WEBPACK FOOTER //
// ./src/pages/shipmentTracking/shipmentTracking.js